import { updateLinksAttributes } from '../../utils/handleAttributes';
import { getWindowSize } from '../../utils/helpers';

let eventsSwiperInstance = null;

const buttonLabels = {
  moreLabel: 'More',
  purchaseLabel: 'Buy Now',
};

const swiperContainers = `
<div class="swiper-arrows-container">
    <div class="wrapper-swiper-container">
      <div class="swiper-container">
        <div class="swiper-wrapper"></div>
      </div>
    </div>
    <div class="swiper-button-prev arrows"></div>
    <div class="swiper-button-next arrows"></div>
</div>

`;

// ------------------------------
// main function
function nextFrame() {
  return new Promise((resolve) => {
    requestAnimationFrame(resolve);
  });
}

function delay(time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}

export default async function eventsSlideshow(eventNumber) {
  const widgetName = 'eventsSlideshow';
  const widgetOpts = eventsSlideshowOpts;
  const normalizedEvent = eventNumber?.toLowerCase().trim();
  const $container = $(`#${widgetName}`);

  const response = await saffire.utils.getWidgetData(widgetOpts);
  const filteredSlides = getFilteredSlides(response.Slides, normalizedEvent);

  $container.addClass('is-fading');

  await nextFrame();
  await delay(300);

  resetSwiper($container);
  renderSlides($container, filteredSlides, widgetName);

  await nextFrame();
  $container.removeClass('is-fading');
}

function getFilteredSlides(slides, normalizedEvent) {
  if (!normalizedEvent) return slides;

  return slides.filter((slide) => {
    return slide.Title?.toLowerCase().trim() === normalizedEvent;
  });
}

// ------------------------------
// reset swiper
function resetSwiper($container) {
  if (eventsSwiperInstance) {
    eventsSwiperInstance.destroy(true, true);
    eventsSwiperInstance = null;
  }

  $container.empty();
  $container.attr({ role: 'tabpanel', 'aria-labelledby': '' });
}

// ------------------------------
// render slideshow
function renderSlides($container, slides, widgetName) {
  requestAnimationFrame(() => {
    $container.removeClass('is-fading');
  });

  if (!slides.length) {
    $container.html(`
      <div class="empty-slideshow">
        <h4>Coming soon, more events</h4>
      </div>
    `);
    return;
  }

  $container.html(`
    <h3 class="headline-desktop"></h3>
    ${swiperContainers}
  `);

  const swiperWidgetWrapper = $container.find('.swiper-wrapper');
  const slidesCountClass = 'slides-' + slides.length;

  $container.find('.arrows').addClass(slidesCountClass);
  swiperWidgetWrapper.addClass(slidesCountClass);

  const slidesHtml = slides.map((slide) => buildSlideTemplate(slide)).join('');
  swiperWidgetWrapper.append(slidesHtml);

  requestAnimationFrame(() => {
    eventsSwiperInstance = initSwiper(widgetName, slides.length);
  });
}

// ------------------------------
// Swiper Initialization
function initSwiper(widget, slidesCount) {
  if (eventsSwiperInstance) {
    eventsSwiperInstance.destroy(true, true);
    eventsSwiperInstance = null;
  }

  const isDesktopLayout = getWindowSize(1245);

  const eventsSwiper = new Swiper(`#${widget} .swiper-container`, {
    speed: 600,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    loop: !isDesktopLayout && slidesCount > 1,
    watchOverflow: isDesktopLayout,
    freeMode: false,
    preloadImages: false,
    lazy: {
      loadPrevNext: false,
      loadPrevNextAmount: 1,
    },
    watchSlidesProgress: true,
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
    preventClicks: true,
    preventClicksPropagation: true,
    grabCursor: true,
    autoHeight: true,
    navigation: {
      nextEl: `#${widget} .swiper-button-next`,
      prevEl: `#${widget} .swiper-button-prev`,
    },
    centeredSlides: false,
    slidesPerView: 5,
    spaceBetween: 20,
    breakpoints: {
      400: {
        slidesPerView: slidesCount == 1 ? 1 : 1.5,
        spaceBetween: 20,
        centeredSlides: true,
        loop: slidesCount > 1,
      },
      500: {
        slidesPerView: slidesCount == 1 ? 1 : 1.5,
        centeredSlides: true,
        loop: slidesCount > 1,
      },
      650: {
        slidesPerView: slidesCount == 1 ? 1 : 2,
        spaceBetween: 5,
        loop: slidesCount > 1,
      },
      880: {
        slidesPerView: 2,
        loop: slidesCount > 2,
      },
      1135: {
        slidesPerView: 3,
        loop: slidesCount > 3,
      },
      1245: {
        slidesPerView: 4,
        loop: slidesCount > 4,
      },
      1300: {
        slidesPerView: 5,
      },
    },
  });

  eventsSwiper.on('transitionEnd', function () {
    eventsSwiper.updateSlidesClasses();
  });

  $(`#${widget}`).on('focusin', '.swiper-slide', function () {
    const realIndex = Number.parseInt($(this).attr('data-swiper-slide-index'), 10);

    if (!Number.isNaN(realIndex) && realIndex !== eventsSwiper.realIndex) {
      eventsSwiper.slideToLoop(realIndex);
    }
  });

  $(`#${widget} .swiper-container`).on('scroll', function () {
    this.scrollLeft = 0;
  });

  return eventsSwiper;
}

// ------------------------------
// buttons
const buttons = function (btn1, btn2) {
  if (!btn1 && !btn2) return '';

  const btnContainer = $('<div class="button-container"></div>');

  if (btn1) {
    btnContainer.append(
      `<a href="${btn1}" class="button" ${updateLinksAttributes(btn1, buttonLabels.moreLabel)}>${buttonLabels.moreLabel}</a>`,
    );
  }

  if (btn2) {
    btnContainer.append(
      `<a href="${btn2}" class="button" ${updateLinksAttributes(btn2, buttonLabels.purchaseLabel)}>${buttonLabels.purchaseLabel}</a>`,
    );
  }

  return btnContainer.prop('outerHTML');
};

// ------------------------------
// Slide Template
function buildSlideTemplate(slide) {
  const { Description, ImageWithPath, URL, PurchaseURL, ImageAlternateText } = slide;
  const emptySlide = !Description && !URL && !PurchaseURL;

  return `
    <div class="swiper-slide ${emptySlide ? 'empty' : ''}">
      <div class="swiper-lineup">
        <div class="swiper-content-container">
          <div class="swiper-image-container swiper-lazy" style="background-image:url('${ImageWithPath}')" data-background="${ImageWithPath}" aria-label="${ImageAlternateText}">
            <div class="overlay"></div>
          </div>
        </div>
      </div>
      <div class="swiper-text-container">
        ${Description ? `<h4 class="slide-title">${Description}</h4>` : ''}
        ${buttons(URL, PurchaseURL)}
      </div>
    </div>
  `;
}
